import { WebsocketSubscriptionMessage } from './types/outboundWebsocketEvent';

type ReplayReconnectSubscriptionsArgs = {
  subscriptions: WebsocketSubscriptionMessage[];
  currentConversationId: number | null | undefined;
  onReplayCurrentConversation: (csid: number) => void;
  onReplayDashboard: () => void;
  sendSubscription: (subscription: WebsocketSubscriptionMessage) => void;
};

export const replayReconnectSubscriptions = ({
  subscriptions,
  currentConversationId,
  onReplayCurrentConversation,
  onReplayDashboard,
  sendSubscription,
}: ReplayReconnectSubscriptionsArgs): void => {
  for (const subscription of subscriptions) {
    if (
      subscription.params.type === 'conversation' &&
      subscription.params.csid === currentConversationId
    ) {
      onReplayCurrentConversation(subscription.params.csid);
      continue;
    }

    if (subscription.params.type === 'real_time_dashboard') {
      onReplayDashboard();
    }

    // Reconnect replay must bypass normal request dedupe/ref-count handling.
    sendSubscription(subscription);
  }
};
